#fc_frame {
	opacity: 0 !important;
}

#fc_frame.fc-open {
	opacity: 1 !important;
}

@media (min-width: 1024px) {
	#fc_frame {
		opacity: 1 !important;
	}
}

.admin-context-menu:hover {
	background: #09708c;
	transition: all 0.3s;
}

.carousel-root.carousel_custom {
	width: 100%;
}
.carousel_custom .carousel .thumbs-wrapper {
	max-width: 900px;
	margin-left: auto;
	margin-right: auto;
	display: flex;
	justify-content: center;
	align-items: center;
}
.carousel_custom .thumbs {
	display: flex;
	margin-top: 3rem;
	gap: 0.5rem;
}
@media only screen and (max-width: 768px) {
	/* For mobile phones: */
	.carousel_custom .thumbs {
		display: flex;
		margin-top: 5.5rem;
		gap: 0.5rem;
	}
}
.carousel_custom li.thumb {
	border: 3px solid transparent;
	background: white;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
}
.carousel_custom li.thumb img {
	max-height: 80px;
}
.carousel_custom li.thumb:hover {
	border: 3px solid #d2eafa;
}
.carousel_custom li.thumb.selected {
	border: 3px solid #2b6fbb;
}
.link {
	cursor: pointer;
	font-weight: 400;
	text-decoration: none;
}
.link--arrowed {
	display: inline-block;
	height: 2rem;
	line-height: 2rem;
}

.link--arrowed .arrow-icon {
	position: relative;
	top: -1px;
	-webkit-transition: -webkit-transform 0.3s ease;
	transition: -webkit-transform 0.3s ease;
	transition: transform 0.3s ease;
	transition:
		transform 0.3s ease,
		-webkit-transform 0.3s ease;
	vertical-align: middle;
}
.link--arrowed .arrow-icon--circle {
	transition: stroke-dashoffset 0.3s ease;
	stroke-dasharray: 95;
	stroke-dashoffset: 95;
}
.link--arrowed:hover .arrow-icon--circle {
	stroke-dashoffset: 0;
}
.signature-container {
	width: 100%;
	margin: 0 auto;
}
.font-select {
	margin-left: auto;
	margin-bottom: 1rem;
	min-width: 150px;
}
.sig-title {
	text-align: left;
	font-size: 1.5rem;
	font-weight: 600;
}
.select__input {
	color: transparent;
}
.signature-container {
	width: 100%;
	margin: 0 auto;
}
.font-select {
	margin-left: auto;
	margin-bottom: 1rem;
	min-width: 150px;
}
.sig-title {
	text-align: left;
	font-size: 1.5rem;
	font-weight: 600;
}
.select__input {
	color: transparent;
}
.signature-tabs {
	display: flex;
	list-style: none;
	padding: 0;
	cursor: pointer;
	margin: 0;
	.clear {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-left: auto;
		font-size: 1.5rem;
		transition: 0.2s ease-in all;

		&:hover {
			transform: rotate(-90deg);
		}
	}
}

.signature-tabs li {
	padding: 10px 20px;
	background-color: #f0f0f0;
	border: 1px solid #ccc;
}

.signature-tabs .active {
	background-color: #fff;
	border-bottom: none;
}

.signature-content {
	border: 1px solid #ccc;
	padding: 20px;
}

.signature-canvas {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.sigCanvas {
	border: 1px solid #ccc;
}

.signature-type {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.signature-type input {
	width: 100%;
	padding: 10px;
	font-size: 24px;
	border: 1px solid #ccc;
	border-top: 0;
	border-right: 0;
	border-left: 0;
	text-align: center;
	margin-bottom: 20px;
	background: transparent;
	font-size: 4rem;
	outline: none;
}
.terms-and-conditions {
	display: flex;
	flex-direction: column;
	font-family: "Roboto", sans-serif;
	.bold {
		font-weight: 700;
		color: black;
	}
	.terms-container > ol {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}
	ol {
		counter-reset: item;
	}
	li {
		display: block;
		font-size: 0.85rem;
		font-weight: 700;
	}
	li > p {
		display: inline;
	}
	ol li::before {
		content: counters(item, ".") ". ";
		counter-increment: item;
	}

	ol ol li::before {
		content: counters(item, ".") " ";
	}
	li ol {
		display: flex;
		flex-direction: column;
		gap: 8px;
		margin-left: 20px;
		margin-top: 8px;
	}
}
.consent {
	font-size: 0.7rem;
	line-height: inherit;
	margin-top: 0.5rem;
	color: #8f8f8f;
	text-align: left;
}
.must-accept {
	color: red;
	padding: 0.5rem;
	background: #ffffff;
	border: 1px solid;
	margin-bottom: 1rem;
	display: block;
	width: 75%;
	margin: 0 auto;
}
.form-dynamic-button {
	max-width: 250px;
	margin: 0 auto;
	background: #244289;
	color: white;
	border-radius: 6px;
	padding: 1rem;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: 700;
	cursor: pointer;
	gap: 0.5rem;
	margin-bottom: 2rem;
}
.terms-container {
	margin-top: 1rem;
	border: 1px solid #ccc;
	height: 300px;
	overflow-y: scroll;
	padding: 1rem;
	margin-bottom: 1rem;
	text-align: left;
	& > h4 {
		margin: 0;
	}
	p {
		font-size: 0.8rem;
		line-height: 1.2rem;
	}
	color: #242424;
	button {
		align-self: center;
	}
}

.checkbox-container {
	display: flex;
	align-items: baseline;
	justify-content: center;
	gap: 0.4rem;
}

.signature-controls {
	display: flex;

	& > p:first-child {
		font-weight: 700;
		font-size: 1.2rem;
	}

	.clear {
		margin-left: auto;
		cursor: pointer;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 1.5rem;
		transition: 0.2s ease-in all;

		&:hover {
			transform: rotate(90deg);
		}
	}
}

.tacbox {
	font-size: 0.8rem;
	display: flex;
	align-items: center;
	padding: 1em;
	border: 3px solid #ddd;
	background-color: #eee;
	max-width: 800px;
	margin-top: 2rem;
	input {
		height: 2em;
		width: 2em;
		margin-right: 1rem;
		vertical-align: middle;
	}
}

.logo-container {
	text-align: center;
	img {
		max-width: 300px;
		margin: 0 auto;
		padding: 1rem;
		padding-block: 2rem;
	}
}
.note-container {
	margin: 0 auto;
	p:nth-of-type(1) {
		font-size: 1.3rem;
		color: #1a428a;
		font-weight: 700;
	}

	p:nth-of-type(2) {
		line-height: 1.2rem;
	}
}

@keyframes megamenu-appear {
	0% {
		transform: translateY(-4px) scaleY(0);
		opacity: 0;
		box-shadow: 0 0 0 rgba(0, 0, 0, 0);
	}
	70% {
		transform: translateY(0) scaleY(1.02);
		box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12);
	}
	100% {
		transform: translateY(0) scaleY(1);
		opacity: 1;
		box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
	}
}

@keyframes megamenu-content-appear {
	0% {
		opacity: 0;
		transform: translateY(6px);
	}
	100% {
		opacity: 1;
		transform: translateY(0);
	}
}

.item-list-base-title {
	font-size: 1.25rem; /* adjust as needed */
	text-decoration: underline;
	text-decoration-color: transparent;
	transition: text-decoration-color 300ms ease-in-out;
	font-size: 1.2rem;
	font-weight: 700;
	font-family: "Roboto", sans-serif;
	color: #173648;
	line-height: 32px;
	transition: all 0.3s;
	margin-block: 0.2rem;
	&:hover {
		text-decoration-color: #1a428a;
		cursor: pointer;
		color: #1a428a;
		/* border-bottom: 1px solid #1a428a;
		cursor: pointer;
		color: #1a428a; */
	}
}
.hovered-title-state {
	text-decoration-color: #1a428a;
	cursor: pointer;
	color: #1a428a;
}
.hover-underline {
	color: #1a428a;
	transition: all 0.3s;
	&:hover {
		text-decoration: underline;
		cursor: pointer;
	}
}
